import React from 'react'
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {CaseForms, UserRoleEnum} from '../../../../helpers/enums'
import {SwitchUser} from '../../../../helpers/helpers';
import CaseGenerator from '../../../CaseGenerator/CaseGenerator'
import digitalizzazioneCustomModalSuccess
  from '../../../CaseGenerator/custom-success-modal/digitalizzazioneCustomModalSuccess';

const DomiciliazioneBancariaComplexCase = () => {
  const auth = useSelector((state) => state.auth);
  const {user} = auth;
  const userProfile = SwitchUser(auth);
  const role = userProfile ? userProfile.role : null;
  const {t} = useTranslation();
  const blockForm = userProfile &&
    userProfile.isCondominiumAdminDisabled && role === UserRoleEnum.CONDOMINIUM_ADMIN;
  return (
    <div className="DomiciliazioneBancariaComplexCase" data-testid="DomiciliazioneBancariaComplexCase">
      <CaseGenerator
        type={CaseForms.DomiciliazioneBancariaComplex}
        block={blockForm}
        signDigital={user && user.role !== 'MUNICIPAL_OPERATOR' ? true : false} // this is mandatory if you want custom success modal
        successModalCustom={
          (props) => digitalizzazioneCustomModalSuccess({t: t, content: "cases.digitalization.success", ...props})
        }
        excludeSteps={user && user.role === 'MUNICIPAL_OPERATOR' ? [9] : []}
        blockText={blockForm && t("associate-contract.block-view")}
      />

    </div>
  )
}

export default DomiciliazioneBancariaComplexCase
